import React, { Fragment } from "react";
import { HashRouter, Route, Redirect, Switch } from "react-router-dom";
import Activate from "Pages/Activate";

const RootRouter = routerProps => {
    const hydrate = Component => props => <Component {...props} {...routerProps} />;
    return (
        <HashRouter>
            <Fragment>
                <Switch>
                    <Route path="/activate" component={hydrate(Activate)} />
                    <Redirect exact from="/" to="/activate" />
                </Switch>
            </Fragment>
        </HashRouter>
    );
};
export default RootRouter;
